import * as React from 'react';
import { NavLink } from 'react-router-dom';

import { Breadcrumb as AntBreadcrumb } from 'antd';

import type IProduct from 'interfaces/IProduct';

type BreadcrumbProps = {
  product: IProduct;
};

function Breadcrumb({ product }: BreadcrumbProps) {
  return (
    <AntBreadcrumb
      items={[
        { title: <NavLink to='/producer/dashboard'>Home</NavLink> },
        { title: <NavLink to='/producer/product/myproducts'>Meus produtos</NavLink> },
        { title: <NavLink to={`/producer/product/editproduct/${product?.id}/sales`}>Edição do produto</NavLink> },
        { title: 'Editar oferta' }
      ]}
    />
  );
}

export { Breadcrumb };
